import React from 'react';

import useLocationCx from './hooks/useLocationCx.hook';
import DeliverToNonLocationCX from './components/DeliverToNonLocationCX';
import DeliverToLocationCx from './components/DeliverToLocationCX';

const AddressDelivery: React.FC = () => {
  const isLocationCx = useLocationCx();

  const Component = isLocationCx ? <DeliverToLocationCx /> : <DeliverToNonLocationCX />;
  return Component;
};
export default AddressDelivery;
